import React, { useCallback, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import * as classes from "./blogsCarousel.module.scss";
import authorImg from '../../assets/images/blog_author.jpg'
import Link from "../../services/utility";
import { useDispatch } from "react-redux";
import { SignupBlog } from "../../services/SEOServices";
import {FailureModalShow} from '../../Store/Action/Action'


const Blogcarousel = ()=>{
    const [BlogData, setBlogData] = useState();
  const dispatch = useDispatch();
  const options = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: true,
    loop: false,
    autoplay: false,
    navText: [
      "<i class='material-icons-outlined owl_arrows'>arrow_back</i>",
      "<i class='material-icons-outlined owl_arrows'>arrow_forward</i>",
    ],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 2,
      },
      700: {
        items: 2,
      },
      1100: {
        items: 3,
      },
    },
  };

  const getBlog = useCallback(() => {
    SignupBlog()
      .then((response) => {
        setBlogData(response.data.data);
      })
      .catch((error) => {
        dispatch(
          FailureModalShow({
            show: true,
            msg: error.message,
          })
        );
      });
  }, []);

  useEffect(() => {
    getBlog();
  }, []);

  return (
    <div className={classes.blogSec}>
      {BlogData && (
        <OwlCarousel className="owl-theme" {...options}>
          {BlogData.map((item, index) => {
            return (
              <>
                <Link key={index}>
                  <div className={classes.items}>
                    <img
                      src={item.thumbnail_image.data?.url || ""}
                      alt={`blog_${index}`}
                    />

                    <h3 className={classes.title}>{item.title}</h3>
                    <p>{item.mini_description}</p>
                    <p className={classes.author}>
                      <img alt={`author${index}`} src={authorImg} />{" "}
                      {item.author}
                      <span>{item.read_time.replace("minutes", "min")}</span>
                    </p>
                    <div className={classes.learnBtn}>
                      <button
                        type="submit"
                        className={`btnoutline`}
                        aria-label={item.title + "LEARN MORE"}
                      >
                        <Link
                          className="SubmitBtn"
                          tabIndex={-1}
                          to={`/blog/${item.id}/${item.title
                            .toLowerCase()
                            .split(" ")
                            .join("-")}`}
                        >
                          LEARN MORE
                        </Link>
                      </button>
                    </div>
                  </div>
                </Link>
              </>
            );
          })}
        </OwlCarousel>
      )}
    </div>
  );
};
export default Blogcarousel;

